/* src/app/auth/signup/signup.component.scss */
.logo {
  width: 430px;
  margin: -50px 0 50px 0;
}
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-top: 40px;
  margin-bottom: 65px;
  color: #a2a6b0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: "Campton-Light";
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 25px;
}
.container input {
  position: absolute;
  cursor: pointer;
  height: 25px;
  width: 25px;
  left: 0px;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #262933;
  border-radius: 3px;
  border: 1px solid #a2a6b0;
}
.container:hover input ~ .checkmark {
  background-color: #555969;
}
.container input:checked ~ .checkmark {
  background-color: #262933;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.container input:checked ~ .checkmark:after {
  display: block;
}
.container .checkmark:after {
  left: 7px;
  top: -1px;
  width: 10px;
  height: 20px;
  border: solid #6ccc09;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.privacy-link {
  color: #a2a6b0;
  text-decoration: none;
  border-bottom: 1px dashed;
}
.form-control:disabled {
  background-color: inherit;
  color: green;
  font-style: bold;
  text-transform: uppercase;
}
.prepopulated {
  display: flex;
  margin-right: 5px;
}
.prepopulated img {
  width: 30px;
}
.input-group {
  position: relative;
  display: flex;
  align-items: center;
}
.input-group .input-group-addon {
  position: absolute;
  right: 10px;
  top: 40%;
  transform: translateY(-50%);
  z-index: 4;
  display: flex;
  align-items: center;
  border-bottom: none;
}
.form-control {
  padding-right: 40px;
}
/*# sourceMappingURL=signup.component.css.map */
